
/* styles */
require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-41982cdd&scoped=true!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PasswordRemindFrom.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./PasswordRemindFrom.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-41982cdd!../../node_modules/vue-loader/lib/selector?type=template&index=0!./PasswordRemindFrom.vue"),
  /* scopeId */
  "data-v-41982cdd",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/page/PasswordRemindFrom.vue
// module id = 611
// module chunks = 0